const _throttle = require('lodash.throttle');

// Mobile nav
window.addEventListener('load', event => {
    let mobileNavToggle = document.getElementById('mobileNavToggle');
    let mobileNavigation = document.getElementById('mobileNavigation');
    let mobileNavDropdownToggle = document.querySelectorAll('.mobile-nav-dropdown-toggle');

    if (mobileNavToggle) {
        mobileNavToggle.addEventListener('click', () => {
            mobileNavToggle.classList.toggle('active');

            if (mobileNavigation) {
                mobileNavigation.classList.toggle('active');
                document.documentElement.classList.toggle('body-lock-scroll');
            }

            for (let navDropdown of mobileNavDropdownToggle) {
                let mobileNavDropdownContent = navDropdown.closest('li').nextElementSibling;
                navDropdown.querySelector('svg').classList.remove('-scale-x-100');
                mobileNavDropdownContent.classList.add('!max-h-0');
                mobileNavDropdownContent.classList.remove('opacity-100');
            }
        });
    }

    for (let navDropdown of mobileNavDropdownToggle) {
        let mobileNavDropdownContent = navDropdown.closest('li').nextElementSibling;
        navDropdown.addEventListener('click', () => {
            navDropdown.querySelector('svg').classList.toggle('-scale-x-100');
            mobileNavDropdownContent.classList.toggle('!max-h-0');
            mobileNavDropdownContent.classList.toggle('opacity-100');
        });
    }
});

// Desktop nav
function updateNavState() {
    const siteHeader = document.getElementById('siteHeader');
    if (!siteHeader) return;

    const headerHeight = siteHeader.offsetHeight;
    const scrollY = window.scrollY || window.pageYOffset;
    const buffer = 5;

    const isActive = scrollY > (headerHeight + buffer);
    siteHeader.setAttribute('data-active', isActive ? 'true' : 'false');
    siteHeader.style.top = isActive ? `-${headerHeight}px` : '0px';
}

// Throttle scroll and resize handler
const handleScrollResize = _throttle(updateNavState, 100);

// Run once on load
window.addEventListener('DOMContentLoaded', updateNavState);
window.addEventListener('load', updateNavState);

// Run on scroll and resize
window.addEventListener('scroll', handleScrollResize);
window.addEventListener('resize', handleScrollResize);
